import { useState, useEffect } from "react";
import moment from "moment-timezone";

import ModalBorrar from "../modals/modalDelete";
import Request from "../../core/httpClient";
import DinamicModal from "../../components/dinamicModal/dinamicModal";
import cogoToast from "cogo-toast";

import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import { useSuperCore } from "../../hooks/useSuperCore";

registerLocale("es", es);

const request = new Request();


function ReservationTable2({ reservas: reservasProp, page: pageProp, pageLength, user: userProp, escritura, reload }) {
  const [reservas, setReservas] = useState(reservasProp);
  const [page, setPage] = useState(pageProp);
  const [comentarios, setComentarios] = useState("");
  const [fianza, setFianza] = useState(null);
  const [fianzaDevolucion, setFianzaDevolucion] = useState(null);
  const [fecha, setFecha] = useState(new Date());
  const [minDay, setMinDay] = useState(new Date());
  const [idHorario, setIdHorario] = useState(0);
  const [user, setUser] = useState(userProp);
  const [horarioOcupado, setHorarioOcupado] = useState({});
  const [idReserva, setIdReserva] = useState(0);
  const [fechaReservaCreacion, setFechaReservaCreacion] = useState(null);
  const [fechaReservaCancelacion, setFechaReservaCancelacion] = useState(null);
  const [reservaCreacion, setReservaCreacion] = useState("");
  const [cancelada, setCancelada] = useState("");
  const [reservaCancelacion, setReservaCancelacion] = useState("");
  const [fechaDevolucion, setFechaDevolucion] = useState(null);
  const [area, setArea] = useState("");
  const [unidad, setUnidad] = useState("");
  const [cantidad, setCantidad] = useState(0);
  const [recibido, setRecibido] = useState("");
  const [devuelto, setDevuelto] = useState("");
  const [fianzaDisabled, setFianzaDisabled] = useState(false);
  const [fianzaDevolucionDisabled, setFianzaDevolucionDisabled] = useState(false);
  const [fechaZona, setfechaZona] = useState(null);


  const [isFianzaDevolucionSet, setIsFianzaDevolucionSet] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [message, setMessage] = useState("");
  const [idArea, setIdArea] = useState(0);




  const { getUserInfo, openModal, openModalDelete } = useSuperCore();
  // sincronizar props con estado
  useEffect(() => { setPage(pageProp); }, [pageProp]);
  useEffect(() => { setReservas(reservasProp); }, [reservasProp]);
  useEffect(() => { setUser(userProp); }, [userProp]);

  const delimitarSeleccionFechas = async (areaSeleccionada) => {
    let min_day = moment().add(parseInt(areaSeleccionada.dias_anticipacion), "days");
    setMinDay(min_day.toDate());
  };
  const setReservaData = async (reserva) => {
    await delimitarSeleccionFechas(reserva);

    const fechaZona = new Date(moment(reserva.fecha_reserva).tz("GMT").format("YYYY/MM/DD"));
    setFecha(fechaZona);
    setfechaZona(fechaZona);

    // Campos de área y unidad
    setArea(reserva.nombre);
    setUnidad(reserva.numero_registro);

    setReservaCreacion(reserva.reserva_creacion);
    setFechaReservaCreacion(moment(reserva.fecha_reserva_creacion).format("DD/MM/YYYY h:mm a"));
    setFechaReservaCancelacion(moment(reserva.fecha_reserva_cancelacion).format("DD/MM/YYYY h:mm a"));
    setCancelada(reserva.cancelada);
    setReservaCancelacion(reserva.reserva_cancelacion);

    setIdReserva(reserva.id_reserva);
    setIdHorario(reserva.IdHorario);

    setHorarioOcupado({
      id_espacio: reserva.id_espacio,
      id_horario: reserva.IdHorario,
      descripcion: reserva.descripcion,
    });

    setFianza(reserva.fianza_cobrada ? reserva.fianza_cobrada : 0);
    setFianzaDevolucion(reserva.fianza_devolucion ? reserva.fianza_devolucion : null);
    setIsFianzaDevolucionSet(reserva.fianza_devolucion > 0);

    setFianzaDevolucionDisabled(!(reserva.fianza_devolucion === 0 || reserva.fianza_devolucion === null));
    setFianzaDisabled(!(reserva.fianza_cobrada === 0 || reserva.fianza_cobrada === null));

    setComentarios(reserva.comentarios);
    setRecibido(reserva.nombre_recibido);
    setDevuelto(reserva.nombre_devolucion);

    setIdArea(reserva.id_espacio);
    setCantidad(reserva.cantidad);
    setFechaDevolucion(reserva.fecha_devolucion);
  };


  const beforeOpenModal = async (reserva) => {
    await setReservaData(reserva);   // actualiza todos los estados con los datos de la reserva
    openModal("editReservation");    // tu lógica para abrir el modal
  };


  const beforeOpenModalDelete = async (reserva) => {
    const userInfo = await getUserInfo();
    setUser(userInfo.info);
    setIdReserva(reserva.id_reserva);
    openModalDelete("deleteReservationAreas"); // ahora sí abre el modal
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoadingSave(true);

    if (fianzaDevolucion > fianza) {
      cogoToast.warn("La cantidad devuelta debe ser igual o menor al depósito de la fianza.", { position: "bottom-right" });
      setLoadingSave(false);
      return;
    }

    const data = {
      fechaActualizacion: moment().format("YYYY-MM-DD"),
      comentarios,
      idReserva,
      idUserDev: parseInt(user.id_usuario),
      fianzaDev: fianzaDevolucion,
      fechaDev: fechaDevolucion
        ? fechaDevolucion
        : fianzaDevolucion
          ? moment().format("YYYY-MM-DD")
          : "",
    };

    const response = await request.post("/commonArea/update/reservation", data);

    if (response.error) {
      cogoToast.error("No se pudo editar reserva.", { position: "bottom-right" });
      setLoadingSave(false);
      return;
    }

    if (response.created) {
      // cerrar modal
      cogoToast.success("Datos actualizados correctamente.", { position: "bottom-right" });
      reload();
    }

    setLoadingSave(false);
  };


  const deleteReservation = async (id) => {
    const data = { Idreserva: id, id_usuario: user.id_usuario };
    const response = await request.post("/commonArea/delet/reservation", data);

    if (response.error || response.empty) {
      cogoToast.error("No se pudo eliminar la reservación.", { position: "bottom-right" });
    }

    if (response.deleted) {
      cogoToast.success("Reservación eliminada.", { position: "bottom-right" });
    }
    // cerrar modal de borrado
    reload();
  };

  //modal ver reserva
  const renderModalEdit = () => (
    <div className="tw-w-full tw-space-y-3">
      {/* Área reservada */}
      <div>
        <label className="tw-block tw-text-sm tw-font-medium tw-text-left tw-text-gray-700 tw-mb-0.5">Área reservada:</label>
        <input
          type="text"
          value={area}
          disabled
          className="input-edit-select-full tw-py-1 tw-text-left"
        />
      </div>

      {/* Unidad */}
      <div>
        <label className="tw-block tw-text-sm tw-font-medium tw-text-left tw-text-gray-700 tw-mb-0.5">Unidad:</label>
        <input
          type="text"
          value={unidad}
          disabled
          className="input-edit-select-full tw-py-1 tw-text-left"
        />
      </div>

      {/* Fecha y Horario */}
      <div className="tw-grid tw-grid-cols-2 tw-gap-2">
        <div>
          <label className="tw-block tw-text-sm tw-font-medium tw-text-left tw-text-gray-700 tw-mb-0.5">Fecha:</label>
          <input
            value={moment(fecha).format("DD/MM/YYYY")}
            disabled
            className="input-edit-select-full tw-py-1 tw-text-left"
          />
        </div>
        <div>
          <label className="tw-block tw-text-sm tw-font-medium tw-text-left tw-text-gray-700 tw-mb-0.5">Horario:</label>
          <select
            value={idHorario}
            disabled
            required
            className="input-edit-select-full tw-py-1 tw-text-left"
          >
            <option value={idHorario}>{horarioOcupado.descripcion || ""}</option>
          </select>
        </div>
      </div>

      {/* Reservas por vivienda */}
      <div>
        <label className="tw-block tw-text-sm tw-font-medium tw-text-left tw-text-gray-700 tw-mb-0.5">Reservas por vivienda:</label>
        <input
          type="text"
          value={cantidad}
          disabled
          className="input-edit-select-full tw-py-1 tw-text-left"
        />
      </div>

      {/* Depósito fianza */}
      {fianza > 0 && (
        <div className="tw-space-y-3">
          <div className="tw-grid tw-grid-cols-2 tw-gap-2">
            <div>
              <label className="tw-block tw-text-sm tw-font-medium tw-text-left tw-text-gray-700 tw-mb-0.5">Depósito fianza:</label>
              <input
                type="number"
                min={0}
                value={fianza}
                onChange={(e) => setFianza(e.target.value)}
                disabled={fianzaDisabled}
                className="input-edit-select-full tw-py-1 tw-text-left"
              />
            </div>
            <div>
              <label className="tw-block tw-text-sm tw-font-medium tw-text-left tw-text-gray-700 tw-mb-0.5">Recibido por:</label>
              <input
                type="text"
                value={recibido}
                disabled
                className="input-edit-select-full tw-py-1 tw-text-left"
              />
            </div>
          </div>

          {/* Devolución fianza */}
          <div className="tw-grid tw-grid-cols-2 tw-gap-2">
            <div>
              <label className="tw-block tw-text-sm tw-font-medium tw-text-left tw-text-gray-700 tw-mb-0.5">Devolución fianza:</label>
              <input
                type="number"
                min={0}
                value={fianzaDevolucion}
                onChange={(e) => setFianzaDevolucion(e.target.value)}
                disabled={fianzaDevolucionDisabled}
                className="input-edit-select-full tw-py-1 tw-text-left"
              />
            </div>
            {isFianzaDevolucionSet && (
              <div>
                <label className="tw-block tw-text-sm tw-font-medium tw-text-left tw-text-gray-700 tw-mb-0.5">Devuelto por:</label>
                <input
                  type="text"
                  value={devuelto ? devuelto : user.usuario}
                  disabled
                  className="input-edit-select-full tw-py-1 tw-text-left"
                />
              </div>
            )}
          </div>
        </div>
        )}

          {/* Fecha de creación */}
          <div className="tw-grid tw-grid-cols-2 tw-gap-2">
            <div>
              <label className="tw-block tw-text-sm tw-font-medium tw-text-left tw-text-gray-700 tw-mb-0.5">Fecha de Creación:</label>
              <input
                type="text"
                value={fechaReservaCreacion || ""}
                disabled
                className="input-edit-select-full tw-py-1 tw-text-left"
              />
            </div>
            <div>
              <label className="tw-block tw-text-sm tw-font-medium tw-text-left tw-text-gray-700 tw-mb-0.5">Creado por:</label>
              <input
                type="text"
                value={reservaCreacion}
                disabled
                className="input-edit-select-full tw-py-1 tw-text-left"
              />
            </div>
          </div>

          {/* Cancelación */}
          {cancelada === "Cancelada" && (
            <div className="tw-grid tw-grid-cols-2 tw-gap-2">
              <div>
                <label className="tw-block tw-text-sm tw-font-medium tw-text-left tw-text-gray-700 tw-mb-0.5">Fecha de Cancelación:</label>
                <input
                  type="text"
                  value={fechaReservaCancelacion || ""}
                  disabled
                  className="input-edit-select-full tw-py-1 tw-text-left"
                />
              </div>
              <div>
                <label className="tw-block tw-text-sm tw-font-medium tw-text-left tw-text-gray-700 tw-mb-0.5">Cancelado por:</label>
                <input
                  type="text"
                  value={reservaCancelacion}
                  disabled
                  className="input-edit-select-full tw-py-1 tw-text-left"
                />
              </div>
            </div>
          )}

          {/* Comentarios */}
          <div>
            <label className="tw-block tw-text-sm tw-font-medium tw-text-left tw-text-gray-700 tw-mb-0.5">Comentarios:</label>
            <textarea
              rows="2"
              value={comentarios}
              onChange={(e) => setComentarios(e.target.value)}
              className="input-edit-select-full tw-py-1 tw-text-left focus:tw-border-purple-500 focus:tw-ring focus:tw-ring-purple-500 focus:tw-ring-opacity-50"
            ></textarea>
          </div>
      </div>
  );


  return (
    <div className="tw-w-full tw-flex tw-flex-col tw-space-y-6" id="card-owners">
      <div className="tw-overflow-x-auto tw-pr-2">
        <table className="tw-min-w-full tw-border tw-border-gray-200 tw-rounded-md tw-shadow-sm tw-text-sm">
          <thead className="tw-bg-gray-100 tw-sticky tw-top-0">
            <tr className="tw-text-left tw-text-gray-700">
              <th className="tw-px-4 tw-py-2">Área reservada</th>
              <th className="tw-px-4 tw-py-2">Fecha</th>
              <th className="tw-px-4 tw-py-2">Vivienda</th>
              <th className="tw-px-4 tw-py-2">Horario</th>
              <th className="tw-px-4 tw-py-2">Estado</th>
              <th className="tw-px-4 tw-py-2 tw-text-center">Ver</th>
              <th className="tw-px-4 tw-py-2 tw-text-center">Cancelar</th>
            </tr>
          </thead>
          <tbody className="tw-divide-y tw-divide-gray-200">
            {reservas
              .slice((page - 1) * pageLength, page * pageLength)
              .map((reserva, key) => (
                <tr key={key} className="hover:tw-bg-gray-50">
                  <td className="tw-px-4 tw-py-2">{reserva.nombre}</td>
                  <td className="tw-px-4 tw-py-2">{moment(reserva.fecha_reserva).tz("GMT").format("DD/MM/YYYY")}</td>
                  <td className="tw-px-4 tw-py-2">{reserva.numero_registro}</td>
                  <td className="tw-px-4 tw-py-2">{reserva.descripcion}</td>
                  <td className="tw-flex tw-px-4 tw-py-2">
                    {reserva.cancelada === "Cancelada" ? (
                      <span className="tw-inline-flex tw-items-center tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-leading-4 tw-text-red-600 tw-bg-red-100 tw-rounded-full tw-gap-1">
                        <i className="fas fa-times-circle"></i>
                        Cancelada
                      </span>
                    ) : reserva.cancelada === "Bloqueada" ? (
                      <span className="tw-inline-flex tw-items-center tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-leading-4 tw-text-gray-600 tw-bg-gray-100 tw-rounded-full tw-gap-1">
                        <i className="fas fa-lock"></i>
                        Bloqueada
                      </span>
                    ) : (
                      <span className="tw-inline-flex tw-items-center tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-leading-4 tw-text-green-600 tw-bg-green-100 tw-rounded-full tw-gap-1">
                        <i className="fas fa-check-circle"></i>
                        Activa
                      </span>
                    )}
                  </td>
                  {reserva.tipo_registro === "Reserva" && (
                  <>
                  <td className="tw-px-4 tw-py-2 tw-text-center">
                    <button
                      className="tw-inline-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded-md tw-bg-purple-400 tw-text-white tw-px-2 tw-py-1 hover:tw-bg-purple-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-purple-500"
                      type="button"
                      onClick={() => beforeOpenModal(reserva)}
                    >
                      <i className="fas fa-eye tw-text-xs" />
                    </button>
                  </td>
                  <td className="tw-px-4 tw-py-2 tw-text-center">
                    {!reserva.cancelada && (
                      <button
                        className={`tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-h-5 tw-w-5 ${escritura
                          ? "tw-bg-red-400 tw-text-white hover:tw-bg-red-700 focus:tw-ring-2 focus:tw-ring-red-500"
                          : "tw-bg-gray-300 tw-text-gray-500 tw-cursor-not-allowed"
                          }`}
                        type="button"
                        onClick={() => beforeOpenModalDelete(reserva)}
                        disabled={!escritura}
                      >
                        <i className="fas fa-ban tw-text-xs" />
                      </button>
                    )}
                  </td>
                  </>
                  )}

                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {/* Modal ver reserva */}
      <DinamicModal
        idModal="editReservation"
        sizeModalContainer="big"
        title="Ver reserva"
        success={handleSubmit}
        btnTextSuccess="ACTUALIZAR"
        btnTextCancel="CANCELAR"
        showBtnSuccess={escritura}
        showBtnCancel={true}
        loadingSave={loadingSave}
        message={message}
      >
        {renderModalEdit()}
      </DinamicModal>

      {/* Modal borrar */}
      <ModalBorrar
        name="deleteReservationAreas"
        id={idReserva}
        delete={deleteReservation}
        cancelar={true}
        message="¿Está seguro de cancelar la reservación?"
      />
    </div>
  );
}

export default ReservationTable2;
